import React from 'react'

import ManojDeskhmukh from '../../../assets/images/recommendations/ManojDeshmukh.jfif'
import SachinJain from '../../../assets/images/recommendations/SachinJain.jfif'
import NitinKuyate from '../../../assets/images/recommendations/NitinKuyate.jfif'
import SubhashRajpurohit from '../../../assets/images/recommendations/SubhashRajpurohit.jfif'
import VinitGadre from '../../../assets/images/recommendations/VinitGadre.jfif'


const recommendations_data = [
	{
        name: 'Manoj Deskhmukh',
		image: ManojDeskhmukh,
		position_company: 'Technology Lead at Infosys',
		recommendation: 'It was fantastic to work together with Piyush. He is high-thinking and hard working team mate. I liked his spirit of working on any problems to get them solved in time.Piyush is very sincere towards his work and taking high responsibility to complete the tasks within time as well as helping other team members.'
    },
    {
        name: 'Sachin Jain',
        image: SachinJain,
        position_company: 'Software Engineer II at Microsoft',
        recommendation: 'Piyush is wonderful to work with, in the short amount of time that i worked with him in couple of different projects, he showed great dedication and willingness to learn, he grasp engineering concepts really well and drive work toward closure.Some of the key area where Piyush really excel are C#, automated testing(Unit and Functional), ASP.NET, Web Accessibility, Microsoft Dynamics CRM.I hope to work again with him in the future and wish him the best.'
    },
    {
        name: 'Nitin Kuyate',
        image: NitinKuyate,
        position_company: 'Product Technical Lead at Infosys',
        recommendation: 'Piyush and me worked together in one of the project, he is a very very polite person, always ready to help junior team members. He has a very good hands on UI technologies and strong programming skill. He will give you solution to every critical problem. All the best buddy!!!'
    },
    {
        name: 'Subhash Rajpurohit',
        image: SubhashRajpurohit,
        position_company: 'Machine Learning Engineer at Aethereus',
        recommendation: 'I was a fresher with no idea about .NET, Piyush was very helpful and polite whenever i went to him with queries. He is a talented coder and great at picking up new technologies. A great teammate to work with!'
    },
    {
        name: 'Vinit Gadre',
        image: VinitGadre,
        position_company: 'Project Manager at Saviant Consulting CSM, ACSM',
        recommendation: 'Piyush on a international client project .He was relatively fresher but was most prominent and promising member in his batch.The level of dedication he had was exceptional.There were situations where we worked thorughout the month without any weekend or leaves but he didnt give up.Good programming skills humble individual, team player.Keep rocking buddy!!'
    }

]

export default recommendations_data;